import Header from "../Header";
import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {submitStep} from "../../network";
import {createConditionalRequire} from '../../utils';
import ReactGA from "react-ga";

const publicUrl = process.env.PUBLIC_URL || '';

const SubjectContent = ({nextStep, currentFormStep, maxStep}) => {
    useEffect(() => {
        ReactGA.pageview(window.location.pathname + "/subjectContent");
    }, []);
    const [isLoading, setLoading] = useState(false);
    const {register, handleSubmit, errors, getValues} = useForm();
    const onSubmit = data => {
        setLoading(true)
        submitStep("subject content", data)
            .then(() => {
                setLoading(false)
                nextStep()
            })
    };
    return (<>
        <Header title="Mida ja kuidas me sellel kursusel õpime"/>
        <progress className="progress is-link" value={currentFormStep} max={maxStep}/>
        <section className="section">
            <div className="container">
                <figure className="image video-container">
                    <iframe className="has-ratio video-iframe"
                            src="https://www.youtube.com/embed/CQg-sTQ4giA?showinfo=0" frameborder="0"
                            allowfullscreen/>
                </figure>
            </div>
            <div className="container">
                <p className="text">
                    Aine on loodud nii, et saad sellega hästi hakkama ilma varasema programmeerimise kogemuseta.
                    Mõndagi uut ja huvitavat leiad aga aines ka siis, kui oled programmeerimisega juba tegelenud.
                </p>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Mida kasulikku me siis ikkagi õpime?
                </h1>
                <p className="text">
                    Kursuse lõpuks oled oluliselt rohkem kodus kuues programmeerimise võtmeteemas:
                </p>
                <ol className="list">
                    <li>
                        Mis on põhilised programmeerimise käsud – ehitusplokid ja tööriistad, mida mistahes keeles
                        kasutab iga programmeerija.
                    </li>
                    <li>
                        Kuidas neid olulisemaid käske kirjutada Pythoni keeles.
                    </li>
                    <li>
                        Rekursioon – elegantne viis lahendada ülesandeid nii, et kasutad ühe funktsiooni (programmi
                        väike tükike, mis lahendab kindlat ülesannet) töö lihtsustamiseks sedasama funktsiooni.
                    </li>
                    <li>
                        Kuidas toimib objektorienteeritud programmeerimine. Objekt on tükk programmist, millel on oma
                        funktsioonid, andmed ja ülesanded.
                    </li>
                    <li>
                        Kuidas programmid saavad kasutada ja toimetada faile.
                    </li>
                    <li>
                        Kuidas programmid saavad lugeda infot veebist (API).
                    </li>
                </ol>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Kuidas see kõik selgeks saada? Töötame veidike iga nädal!
                </h1>
                <p className="text">
                    Programmeerimine on ennekõike praktiline oskus.
                    Selleks, et tulevikus oleks lihtne kodeerida, lahendame igal nädalal ülesandeid, mis lähevad järjest
                    keerulisemaks ja põnevamaks.
                </p>
                <p className="text">
                    Oleme kogenud seda, et tudengid, kes teevad ülesandeid iga nädal, saavad mõistliku pingutusega hästi
                    hakkama.
                    Kui aga vahepeal lasta pikem paus sisse, võib minna oluliselt keerulisemaks.
                    Kui nii peaks ikkagi juhtuma, pea meeles, et oleme toeks ja pingutame koos Sinuga, et saada järjele
                    tagasi.
                </p>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Mis selles kõiges siis keerulist on?
                </h1>
                <p className="text">
                    Programmeerimises on vaja mõelda abstraktselt – teatud mõttes tuleb enne koodiridade kirja panemist
                    programm, või selle osad, tervikuna valmis mõelda.
                </p>
                <p className="text">
                    Koolis puutusid kokku matemaatikaülesannetega, mida tuli lihtsalt lahendada.
                    Selles aines läheme sammu edasi – kirjeldame ära, kuidas arvuti peaks lahendama
                    matemaatikaülesannet.
                    Näiteks tekstiülesande lahendamise asemel kirjeldame arvutile üldistatud juhendi, kuidas sellist
                    tüüpi ülesannet peaks lahendama.
                </p>
                <p className="text">
                    See on tegelikult väga põnev!
                    Aga ole valmis ka selleks, et mõnikord on see ka harjumatu ja raske - võib tekkida tunne, et ei saa
                    kohe hakkama.
                    See tunne on OK, kuid pane end selleks valmis ja küsi julgelt abi!
                </p>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Abistav kursus
                </h1>
                <figure className="image video-container">
                    <iframe className="has-ratio video-iframe"
                            src="https://www.youtube.com/embed/O-MMknEB7ZI?showinfo=0" frameborder="0"
                            allowfullscreen/>
                </figure>
                <p className="text">
                    Lisaks algkursusele toimub sügisel Programmeerimise täiendusõpe, mis kestab 1. – 5. õppenädalal.
                    Selles aines anname täiendavaid ülesandeid, et saaksid oma programmeerimisoskust arendada.
                    Seda ainet saab ÕIS-is deklareerida ainekoodiga ITI0002.
                    Räägin sellest täpsemalt esimeses loengus.
                </p>
            </div>
            <form className="container" onSubmit={handleSubmit(onSubmit)}>
                <h1 className="subtitle form-question">
                    Kas on mõni teema, mida tahaksid lisaks õppida?
                </h1>
                <textarea ref={register({required: false})} name="wantToLearn" className="textarea"
                          placeholder="Kirjuta oma mõtted siia"></textarea>

                <h1 className="subtitle form-question">
                    Mis tundeid kogu see jutt Sinus tekitab?
                </h1>


                <div className="control">
                    <label className="radio">
                        <input ref={register({required: true})} type="radio" name="answer" value="I like challenges"/>
                        Teeme ära, mulle väljakutsed meeldivad
                    </label>
                </div>

                <div className="control">
                    <label className="radio">
                        <input ref={register({required: true})} type="radio" name="answer" value="I can handle"/>
                        Kõik sobib, saan hakkama
                    </label>
                </div>

                <div className="control">
                    <label className="radio">
                        <input ref={register({required: true})} type="radio" name="answer" value="so-so"/>
                        Nii ja naa
                    </label>
                </div>

                <div className="control">
                    <label className="radio">
                        <input ref={register({required: true})} type="radio" name="answer" value="a bit scary"/>
                        Pigem kõhedusttekitav, tundub keeruline värk
                    </label>
                </div>

                <div className="control">
                    <label className="radio">
                        <input ref={register({required: true})} type="radio" name="answer" value="doubt"/>
                        Ma pole enam üldse kindel, kas saan ainega hakkama
                    </label>
                </div>

                <div className="control">
                    <label className="radio">
                        <input ref={register({required: true})} type="radio" name="answer" value="problem"/>
                        Mul on mure (kirjuta kindlasti kommentaar)
                        <input name="answerProblem"
                               ref={register(createConditionalRequire(getValues, "answer", "problem"))}
                               className="input" type="text"/>
                    </label>
                </div>


                {Object.keys(errors).length ? <div className="validation-error">
                    Jätkamiseks vasta palun kõigile küsimustele!
                </div> : null}
                <button className={`button is-large is-rounded take-test-button ${isLoading ? 'is-loading' : ''}`}
                        disabled={isLoading}>JÄRGMINE →
                </button>
            </form>
        </section>
    </>);
};

export default SubjectContent;
